import { makeAutoObservable } from 'mobx';
import { SetNonNullable } from 'type-fest';
import { getUchiLoginRedirectUrl } from 'shared/helpers/getUchiLoginRedirectUrl';
import { getUnauthorizedPaymentRedirectChainUrl } from 'shared/helpers/paymentRedirect';
import { COURSE_URL } from './constants';

class MagicMath2Store {
  isReady = false;

  studentId: number | null = null;

  studentParallel: number | null = null;

  hasPremium = false;

  price = 0;

  basePrice = 0;

  // По умолчанию не авторизованы, пока не вызвали `init` с платёжной инфой.
  paymentUrl = getUnauthorizedPaymentRedirectChainUrl();

  constructor() {
    makeAutoObservable(this);
  }

  get isAuthorized() {
    return !!this.studentId;
  }

  get adaptedCourseUrl() {
    return this.isAuthorized ? COURSE_URL : getUchiLoginRedirectUrl(COURSE_URL);
  }

  get eventSource() {
    return `magic_math2_${this.studentParallel}`;
  }

  init(data: MagicMath2StoreData) {
    (Object.keys(data) as Array<keyof MagicMath2StoreData>).forEach((key) => {
      // @ts-ignore
      this[key] = data[key];
    });

    this.isReady = true;
  }

  setIsReadyNotLoggedIn() {
    this.isReady = true;
  }
}

type MagicMath2StoreData = SetNonNullable<
  Pick<
    MagicMath2Store,
    'studentId' | 'studentParallel' | 'hasPremium' | 'price' | 'basePrice' | 'paymentUrl'
  >
>;

export const store = new MagicMath2Store();
